/**
 * Replaces placeholders in a string with corresponding values from an object.
 * `${}` 안에 있는 플레이스홀더를 객체의 값으로 대체
 * @param {string} str - The string containing placeholders to be replaced.
 * @param {object} obj - The object containing values to replace the placeholders.
 * @returns {string} The string with placeholders replaced by values from the object.
 */
export const replacePlaceholder = (str, obj) => {
  // Regular expression to match placeholders in the format ${key.subkey}
  if (!str || !obj) {
    return undefined
  }
  const regExp = /\${(.*?)}/gi

  return str.replace(regExp, (_, match) => {
    return match.split('.').reduce((acc, key) => {
      return acc && acc[key] ? acc[key] : ''
    }, obj)
  })
}
